import { useLocation } from 'react-router-dom';

import { SeletorNoCelular } from '@/components/ui/SeletorNoCelular';
import { useNavegacao } from '@/lib/navegacao/use-navegacao';
import { secaoDaRota } from '@/lib/navegacao/navegacao';

/**
 * No celular, o topo de toda tela que pertence a uma área com sub-seções
 * (Comercial, Manutenção, Compras, Financeiro) mostra a área e a seção numa
 * linha — "Manutenção: Corretiva ▾" — que abre as outras seções no lugar.
 *
 * MOBILE-COMPLETO (M2): o botão "OS" da barra inferior caía em Preventiva sem
 * saída para Chamados, Corretiva, Orçamentos… Agora qualquer sub-seção está a
 * um toque. As seções vêm da MESMA definição do menu do computador
 * (`useNavegacao`), então permissão e item novo valem aqui sozinhos.
 * ⚠️ Só abaixo de `md` — no computador o menu lateral já faz esse papel.
 */
export function SeletorDaArea() {
  const { pathname } = useLocation();
  const secoes = useNavegacao();
  const achado = secaoDaRota(secoes, pathname);
  if (!achado || achado.item.subItens.length < 2) return null;
  return (
    <SeletorNoCelular
      className="px-4 pt-4"
      testId="seletor-da-area"
      rotulo={achado.item.label}
      opcoes={achado.item.subItens.map((s) => ({
        chave: s.to,
        label: s.label,
        to: s.to,
        ativa: achado.sub?.to === s.to,
      }))}
    />
  );
}
